import {
    CLEAR_STATIC_DATA,
    FETCH_STATIC_DATA_FAILURE,
    FETCH_STATIC_DATA_REQUEST,
    FETCH_STATIC_DATA_SUCCESS,
    StaticDataActionTypes,
    StaticDataState,
} from '../types/staticDataTypes';

const initialState: StaticDataState = {
    services: [],
    languages: [],
    cities: [],
    provinces: [],
    licenseTypes: [],
    isLoading: false,
    isLoaded: false,
    lastFetched: null,
    error: null,
};

const staticDataReducer = (
    state = initialState,
    action: StaticDataActionTypes
): StaticDataState => {
    switch (action.type) {
        case FETCH_STATIC_DATA_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case FETCH_STATIC_DATA_SUCCESS:
            return {
                ...state,
                services: action.payload.services,
                languages: action.payload.languages,
                cities: action.payload.cities,
                provinces: action.payload.provinces,
                licenseTypes: action.payload.licenseTypes,
                isLoading: false,
                isLoaded: true,
                lastFetched: Date.now(),
                error: null,
            };
        case FETCH_STATIC_DATA_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        case CLEAR_STATIC_DATA:
            return initialState;
        default:
            return state;
    }
};

export default staticDataReducer;
